<template>
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>18-account</title>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-1306.000000, -25.000000)" fill="#000000">
        <g transform="translate(1241.000000, 25.000000)">
          <g transform="translate(65.000000, 0.000000)">
            <path
              d="M9.9,1.78615385 C7.911774,1.78615385 6.3,3.38552958 6.3,5.35846154 C6.3,7.33139349 7.911774,8.93076923 9.9,8.93076923 C11.88819,8.93076923 13.5,7.33139349 13.5,5.35846154 C13.5,3.38552958 11.88819,1.78615385 9.9,1.78615385 Z M13.29678,9.52421885 C14.5188,8.54183423 15.3,7.04067016 15.3,5.35846154 C15.3,2.39906361 12.88233,0 9.9,0 C6.917661,0 4.5,2.39906361 4.5,5.35846154 C4.5,7.04067016 5.281173,8.54183423 6.503202,9.52421885 C3.004713,10.7922095 0.429543,13.9629898 0.048699,17.7746421 C-0.0587502,18.8500853 0.832527,19.6476923 1.8,19.6476923 L18,19.6476923 C18.9675,19.6476923 19.85877,18.8500853 19.75131,17.7746421 C19.37043,13.9629898 16.79526,10.7922095 13.29678,9.52421885 Z M9.9,10.7169231 C5.730876,10.7169231 2.296485,13.8431388 1.849356,17.8615385 L17.95068,17.8615385 C17.50347,13.8431388 14.06916,10.7169231 9.9,10.7169231 Z"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "user-icon",
};
</script>
